<template>
    <b-overlay :show="tableLoading" rounded="sm" >
        <b-modal v-model="isModalVisible" id="message-modal" hide-footer :close-on-backdrop="false" class="pt-8" centered
        header-class="p-0" footer-class="d-flex justify-content-center border-0" content-class="custom-model-wrap">
        <template #modal-title>
            <div class="title-block text-center p-2 m-0">
              {{$translate('customer_document')}}
            </div>
        </template>
        <b-col cols="12" class="mt-3">
           
            <label class="mb-3"><strong>{{ $translate('document') }}</strong></label>
            <b-form-input type="text" id="input-document-name" v-model="document_name"
             disabled></b-form-input>
            </b-col>
          
       
        <b-col cols="12" class="mt-3" >
           
                <label class="mb-3"><strong>{{ $translate('documents') }}</strong>
                </label><br>
                <b-img v-if="['jpg', 'jpeg', 'png'].includes(document.extension)" :src="document.url" fluid alt="Responsive image"></b-img>
                <a :id="'master-xls-file-1'" v-else-if="['xls', 'xlsx'].includes(document.extension)" :href="document.url"  @click="downloadFile($event, document)">
                    <div class="btn btn-success btn-sm">
                        <i v-b-tooltip.hover :title="$translate('click_to_download')" class="fa-solid fa-file-excel fa-2x"></i>
                    </div>
                </a>
                <a :id="'master-pdf-file-1'" v-else-if="document.extension === 'pdf'" :href="document.url" @click="downloadFile($event, document)">
                    <div class="btn delete-button btn-sm">
                        <i v-b-tooltip.hover :title="$translate('click_to_download')" class="fa fa-file-pdf fa-2x"></i>
                    </div>
                </a>
           
        </b-col>
        
       
        <div class="d-flex justify-content-center mt-3">
            <!-- <b-button  size="sm" @click="createDocument" class="btn-fw me-3" 
                 variant="info">{{ model.id
                    ? $translate('update_master_document') : $translate('add_master_document') }}</b-button> -->
            <b-button size="sm" id="close-master-model" @click="isModalVisible = false" variant="info" class="btn-fw">{{ $translate('close')
            }}</b-button>
        </div>
    </b-modal>
        <b-card class="inner-block health-listing">
            <b-card-header>
                <b-row class="mt-2">
                    <!-- <b-col cols="2" md="1" lg="1"
                        class="d-flex align-items-center justify-content-center"><strong>health</strong></b-col>
                    <b-col cols="10" md="11" lg="11" class="d-flex"> -->
                   
                </b-row>
                <b-row class="mt-2 justify-content-end">
                   
                    <!-- <b-col cols="2" md="1" lg="1"
                        class="d-flex align-items-center justify-content-center"><strong>health</strong></b-col>
                    <b-col cols="10" md="11" lg="11" class="d-flex"> -->
                    <b-col cols="12"  class="d-flex gap-1 gap-md-2 ps-3 mt-1 mt-md-0 align-self-baseline align-self-md-center master-item-button"
                    >
                 
                        <b-button
                        id="add-checkoff-btn"
                        variant="blue-button"
                        v-b-tooltip.hover
                        :title="$addLabel()"
                       
                        @click="addDocumentType"
                        >
                        <img src="@/assets/images/icon/gradient-add.svg" /> {{$translate('New')}}
                        </b-button>
          
                        <!-- <b-button
                        id="import-checkoff-item-btn"
                        variant="blue-icon"
                        v-b-tooltip.hover
                        :title="$translate('import')"
                        @click="openModel()"
                        v-if="hasPermissionCreate"
                      >
                        <img src="@/assets/images/icon/import.svg" />
                      </b-button> -->
                      <!-- <b-button
                      id="export-checkoff-item-btn"
                      variant="blue-icon"
                      v-b-tooltip.hover
                      :title="$translate('export')"
                      @click="export_roster()"
                      v-if="hasPermissionCreate"
                    >
                      <img src="@/assets/images/icon/export.svg" />
                    </b-button> -->
                     <b-button id="reset-filter-btn" variant="blue-button" @click="resetFilters" v-b-tooltip.hover
                         :title="$translate('reset_filters')">
                         <b-icon icon="arrow-repeat" class="fs-2" variant="dark" style=" font-size: 1.5rem"></b-icon>
                     </b-button>
                     <b-button variant="blue-button" id="toggle-filter-btn"   class="me-2"
                     @click="toggle_filters = !toggle_filters" v-b-tooltip.hover
                     :title="$translate('filter')">
                    
                     <b-icon class="fs-2" style=" font-size: 1.5rem" :icon="'chevron-' +
                         (toggle_filters ? 'up' : 'down')
                         " variant="dark"></b-icon>{{$translate('Filters')}}
                 </b-button>
                    </b-col>
                </b-row>
                <Filters v-show="toggle_filters" v-model="filters" />
            </b-card-header>
            <b-card-body class="button-off">
                <b-col class="page-block">
                    <strong>
                        {{ $translate('page') }}: {{ pagination.page }} {{ $translate('of') }} {{ pageCount }} {{
                            $translate('total') }}:
                        {{ pagination.total }}
                    </strong>
                </b-col>
                <b-col class="overflow-auto w-100 mt-4">
                    <b-table show-empty :empty-text=" $translate('records_not_found')" id="healthTable" responsive :items="customer_document" :fields="fields">
                        <template>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <!-- <strong>{{ $translate('loading') }}</strong> -->
                            </div>
                        </template>
                        <template #cell(name)="row">
                            <span>
                                {{ row.item.file_name }}({{ row.item.extension }})
                            </span>
                        </template>
                        <template #cell(id)="row">
                           
                            <b-button :id="'view-document-btn-'+row.item.id" @click="open_model(row.item)"  class="mr-2 test-view-document-btn" variant="pink-button">
                                <img src="@/assets/images/icon/view.svg" />
                            </b-button>
                            <!-- <b-button @click="view(row.item.id)" v-if="hasPermissionView" class="mr-2" variant="pink-button">
                                <img src="@/assets/images/icon/view.svg" />
                            </b-button> -->
                        </template>
                     
                    </b-table>
                </b-col>
                <b-row>
                    <b-col>
                        <b-pagination class="justify-content-center mt-4" v-model="pagination.page"
                            :total-rows="pagination.total" :per-page="pagination.pageSize" aria-controls="customerTable"
                            :prev-text="$translate('previous')" :next-text="$translate('next')" pills
                            align="right"></b-pagination>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
    </b-overlay>
</template>
<script>
import _ from 'lodash'

import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import Filters from './Filters'
import moment from 'moment';
export default {
    name: 'Customer-Document',
    mixins: [popupMixins, permissionsMixins],
    props: {
        type: {
            type: String,
        },
        title: String,
    },
    components: {
        Filters,
        
    },
    data() {
        return {
            query: '',
            tableLoading: false,
            toggle_filters: false,
            filters: {
                start_date: "",
                end_date : "",
                attached_to: "",
               
            },
            isModalVisible : false,
            document: '',
            document_name :'',
         
        }
    },
    computed: {
        fields() {
            return [
                { key: 'id', label: this.$translate('actions') },
                { key: 'name', label: this.$translate('file_name') },
                { key: 'attached_to', label: this.$translate('attached_to'), formatter: value =>
                        value ? value  : '' },
                { key: 'type_group', label: this.$translate('type_group') },
                { key: 'attached_by', label: this.$translate('attached_by')},
                { key: 'date_time', label: this.$translate('attachment_date_time'),
                formatter: value => this.formatDateTime(value) },
             
               
            ]
        },
        pageCount() {
            return Math.ceil(this.pagination.total / this.pagination.pageSize)
        },
        customer_document() {
            const customer_document = this.$store.state.customer_document.items
           
            return customer_document
        },
        pagination() {
            return this.$store.state.customer_document.pagination || {page: 1}
        },
      
    },

    watch: {
        customer_document: {
            handler: function () {
                this.tableLoading = false
            },
            deep: true,
        },
        'pagination.page': function (newPage) {
            this.changePage(newPage)
        },
        query: _.debounce(function (query) {
            this.$router.push({ query: { query } })
            this.doSearch()
        }, 200),
        filters: {
            handler: function () {
             
                this.doSearch()
            },
            deep: true,
        },
    },

    mounted() {
        if (this.$route.query.query) this.query = this.$route.query.query
        this.doSearch()
    },

    methods: {
       
        changePage(page) {
            this.$router.push({ query: { page } })
            this.doSearch()
        },
        async doSearch() {
            try {
                this.tableLoading = true;
                const {
                    pagination: { page },
                    query,
                    filters
                } = this
             ;
                let attached_to  = "";
                if (filters.attached_to && filters.attached_to.length > 0 && Array.isArray(filters.attached_to)) {
                    attached_to = filters.attached_to.map((i) => i.id).join(",");
                }
                let keywords  = "";
                if (filters.keywords && filters.keywords.length > 0 && Array.isArray(filters.keywords)) {
                    keywords = filters.keywords.map((i) => i.id).join(",");
                }
               
             
                await this.$store.dispatch('customer_document/fetch', {
                    query,
                    page,
                    filters: { ...filters,attached_to : attached_to,keywords: keywords}
                })
            } catch (error) {
                console.error('loading error', error)
            }
        },
        view(id) {
        console.log('Clicked id:', id); // Check if this logs the correct id
        alert('id --- ' + id); // For debugging
        this.$router.push({ name: 'customerDocument', params: { id } });
        },
        addDocumentType() {
            const id = 0
            this.$router.push({ params: { id }, name: 'customerDocument' })
        },
        truncate(text, length) {
            return _.truncate(text, { length: length })
        },
        resetFilters() {
            this.filters = {
                start_date: "",
                end_date:"",
                attached_by : "",
                attached_to:"",
                keywords : "",
                search: "",
                customer_id :this.$store.state.customers.item.id,
                
            }
            this.doSearch()
        },
        formatDateTime(value) {
        return value ? moment(value).format('YYYY-MM-DD hh:mm A') : '';
        },
        open_model(data){
            this.document_name = data.file_name;
          
            this.document = data;
            this.isModalVisible = true;
        },
        downloadFile(event, attachment) {
        event.preventDefault();
        fetch(attachment.url)
            .then(response => response.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = attachment.file_name;  // This sets the name of the downloaded file
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            })
            .catch(error => console.error('Download error:', error));
    }
    },
}
</script>
<style></style>
